import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import BeforeAfterSlider from '../components/BeforeAfterSlider';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const EmbedSlider = () => {
  const { assetId } = useParams();
  const [asset, setAsset] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAsset = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/assets/${assetId}/public`);
        setAsset(response.data);
      } catch (err) {
        setError('Slider not found');
      } finally {
        setLoading(false);
      }
    };

    fetchAsset();
  }, [assetId]);

  if (loading) {
    return (
      <div style={{ 
        width: '100%', 
        height: '100%', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        fontFamily: 'system-ui, sans-serif',
        color: '#64748b'
      }}>
        Loading...
      </div>
    );
  }

  if (error || !asset) {
    return (
      <div style={{ 
        width: '100%', 
        height: '100%', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        fontFamily: 'system-ui, sans-serif',
        color: '#64748b'
      }}>
        {error || 'Not found'}
      </div>
    );
  }

  // Build image URLs
  const sliderBefore = asset.slider_images?.before 
    ? `${API_URL}${asset.slider_images.before}`
    : asset.images?.[0]?.startsWith('http') 
      ? asset.images[0] 
      : `${API_URL}${asset.images?.[0] || ''}`;
      
  const sliderAfter = asset.slider_images?.after 
    ? `${API_URL}${asset.slider_images.after}`
    : asset.images?.[asset.images.length - 1]?.startsWith('http') 
      ? asset.images[asset.images.length - 1] 
      : `${API_URL}${asset.images?.[asset.images.length - 1] || ''}`;

  return (
    <div style={{ 
      width: '100%', 
      height: '100%', 
      background: '#f8f9fa',
      padding: '8px',
      boxSizing: 'border-box'
    }}>
      <BeforeAfterSlider
        beforeImage={sliderBefore}
        afterImage={sliderAfter}
        aspectRatio="1/1"
      />
    </div>
  );
};

export default EmbedSlider;
